import makeStyles from '@mui/styles/makeStyles';
import { MENU_WIDTH } from '../desktop/BlockItem/Content/Menu/constants';

export const useStyles = makeStyles((theme) => ({
  innerWrapper: {
    border: `1px solid ${theme.palette.grey[200]}`,
    boxShadow: 'none',
    display: 'flex',
    minHeight: 80,
    position: 'relative',
    width: 'calc(100% - 1px)',
  },
  title: {
    display: '-webkit-box',
    overflow: 'hidden',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',

    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  },
  media: {
    backgroundColor: theme.palette.grey[200],
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    minHeight: 80,
    overflow: 'hidden',
    width: '20%',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    width: `calc(100% - ${MENU_WIDTH}px)`,
  },
  listItemIcon: {
    minWidth: '40px',
  },
  link: {
    color: theme.palette.common.black,
  },
  alreadyUsed: {
    position: 'absolute',
    bottom: 2,
  },
  scheduledIcon: {
    width: MENU_WIDTH,
    textAlign: 'center',
  },
  wrapper: {
    borderTop: `solid 12px transparent`,
  },
}));
